'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _IyvListTable = require('./IyvListTable.css');

var _IyvListTable2 = _interopRequireDefault(_IyvListTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListViewPanelTabs = (_dec = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListViewPanelTabs, _Component);

  //
  function IyvListViewPanelTabs(props) {
    (0, _classCallCheck3.default)(this, IyvListViewPanelTabs);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IyvListViewPanelTabs.__proto__ || (0, _getPrototypeOf2.default)(IyvListViewPanelTabs)).call(this, props));

    var viewTabConfig = null;
    switch (_config2.default.app.title) {
      case 'Fossil Free Funds':
        viewTabConfig = [['results', 'Fossil fuels'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Deforestation Free Funds':
        viewTabConfig = [['results', 'Deforestation'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Weapon Free Funds':
        viewTabConfig = [['results', 'Military weapons'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Gun Free Funds':
        viewTabConfig = [['results', 'Civilian firearms'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Tobacco Free Funds':
        viewTabConfig = [['results', 'Tobacco'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Gender Equality Funds':
        viewTabConfig = [['results', 'Gender equality'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Prison Free Funds':
        viewTabConfig = [['results', 'Prison industrial complex'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Invest Your Values':
        viewTabConfig = [['results', 'Sustainability'], ['performance', 'Performance']];
        break;
      default:
        break;
    }
    _this.state = {
      viewTabConfig: viewTabConfig
    };
    return _this;
  }
  //


  (0, _createClass3.default)(IyvListViewPanelTabs, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { styleName: 'view-panel-tabs' },
        /* view panel config is [id string, label string]*/
        this.state.viewTabConfig.map(function (viewPanel, idx) {
          return _react2.default.createElement(
            'button',
            {
              key: 'viewpanel-tab-' + idx,
              onClick: function onClick() {
                _this2.props.setViewPanel(viewPanel[0]);
              },
              styleName: _this2.props.viewPanel === viewPanel[0] ? 'view-panel-tab-active' : 'view-panel-tab',
              role: 'button',
              tabIndex: '0'
            },
            viewPanel[1]
          );
        })
      );
    }
  }]);
  return IyvListViewPanelTabs;
}(_react.Component), _class2.propTypes = {
  setViewPanel: _react.PropTypes.func.isRequired,
  viewPanel: _react.PropTypes.string
}, _temp)) || _class);
exports.default = IyvListViewPanelTabs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListTable/IyvListViewPanelTabs.js
// module id = 1386
// module chunks = 0